import { render, staticRenderFns } from "./AuthenticationStep3.vue?vue&type=template&id=56379e28&scoped=true"
import script from "./AuthenticationStep3.vue?vue&type=script&lang=ts"
export * from "./AuthenticationStep3.vue?vue&type=script&lang=ts"
import style0 from "./AuthenticationStep3.vue?vue&type=style&index=0&id=56379e28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56379e28",
  null
  
)

export default component.exports